<template>
  <div class="light select-button">
    <button
      class="select-button__item"
      v-for="currency in currencyList"
      :key="currency"
      @click="currentValue=currency"
      :class="{'button--active': currency === props.value}"
    >
      {{ currency }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Currency } from '@/types';

const props = defineProps<{
  currencyList: Currency[];
  value: Currency;
}>();

const emit = defineEmits<{
  (e: 'input', value: Currency): void;
}>();

const currentValue = computed({
  get: () => props.value,
  set: (newValue: Currency) => {
    emit('input', newValue);
  },
});
</script>

<style lang="scss" scoped>
@use '@kanoAssets/styles/breakpoints.scss';

.select-button {
  display: flex;
  gap: 2px;

  &__item {
    background-color: var(--color-base-4);
    border-radius: 6px;
    border: 1px solid transparent;
    padding: 4px 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: var(--color-base);
    transition:
      background-color 0.2s ease-out,
      border-color 0.2s ease-out,
      color 0.2s ease-out;
    cursor: pointer;

    @include breakpoints.desktop {
      line-height: 16px;
    }

    &:hover,
    &:focus {
      background-color: transparent;
      border-color: var(--color-base-4);
      color: var(--color-base-48);
    }

    &.button--active {
      color: var(--color-base-0);
      background-color: var(--color-base);
    }
  }
}
</style>
